import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from '../pages/Login';
import Home from '../pages/Home';
import Register from '../pages/Register';
import EditLlamada from '../pages/EditLlamada';
import Llamadas from '../pages/Llamadas'
import Documentacion from '../pages/Documentacion';
import Gestion from '../pages/Gestion';
import DocuCurso from '../pages/DocuCurso';
import Alfresco from '../pages/Alfresco';
import Cliente from '../pages/Cliente';
import LoginCliente from '../pages/LoginCliente';
import Plantilla from '../pages/Plantilla';


function Path(){
    return(
        <div>
            <Routes>
            <Route exact path="/" element={<Login></Login>} />
            <Route path="/login" element={<Login></Login>} />
            <Route path="/home" element={<Home></Home>} />
            <Route path="/register" element={<Register></Register>} />
            <Route path="/edit/:id_llamada" element={<EditLlamada />} /> 
            <Route path="/llamadas" element={<Llamadas></Llamadas>} />
            <Route path="/documentacion" element={<Documentacion></Documentacion>} />
            <Route path="/gestion" element={<Gestion></Gestion>} />
            <Route path="/revisar/:wp_id" element={<DocuCurso />} />
            <Route path="/alfresco" element={<Alfresco></Alfresco>} />
            <Route path="/cliente/:cliente_id" element={<Cliente />} />
            <Route path="/alumno" element={<LoginCliente />} />
            <Route path="/plantilla" element={<Plantilla></Plantilla>} />
            </Routes>

        </div>
    )
}

export default Path;